<template>
	<div>
		<div style="display: inline-flex; align-items: center">
			<div>
				<i style="font-size: 20px; margin-right: 10px" class="icon-puzzlepiece"></i>
			</div>
			<div>
				<h2>Publish Workflow Template</h2>
			</div>
		</div>
		<p style="margin-top: 0px">
			Publish the workflow named <b>{{ workflowToPublish ? workflowToPublish.name : "" }}</b> as a reusable
			template
		</p>
		<templatePreview ref="templatePreview" :workflowObject="workflowToPublish" />
		<el-divider class="compressedDivider"></el-divider>
		<el-container>
			<el-aside class="publishWorkflowFormWrapper">
				<el-form :rules="formRules" label-position="top" label-width="100px" :model="form">
					<el-form-item prop="public" label="Template Accesibility">
						<el-switch style="margin-left: -10px" v-model="form.public"
							:active-text="form.public ? 'Public To Everyone' : 'Private To Organisation'"
							inactive-text=" "></el-switch>
					</el-form-item>
					<el-form-item label="Industry">
						<el-input placeholder="e.g Financial Services" v-model="form.industry"></el-input>
					</el-form-item>

					<el-form-item label="Department">
						<el-input placeholder="e.g Compliance" v-model="form.department"></el-input>
					</el-form-item>

					<el-form-item prop="searchTags" label="Add Filter Tags">
						<el-select v-model="form.searchTags" multiple filterable allow-create default-first-option
							style="width: 100%" placeholder="Type and press enter">
						</el-select>
					</el-form-item>
				</el-form>
			</el-aside>
			<el-main>
				<el-form ref="form" :rules="formRules" label-position="top" label-width="100px" :model="form">
					<el-form-item prop="name" label="Name The Template">
						<el-input @keyup.enter.native="publish()" maxlength="50" placeholder="Template name"
							v-model="form.name"></el-input>
						<!-- Hidden input to stop page refresh on enter -->
						<el-input v-show="false" maxlength="50" placeholder="Template name"
							v-model="form.name"></el-input>
					</el-form-item>
					<el-form-item prop="description" label="Describe The Template">
						<el-input :autosize="{ minRows: 3, maxRows: 3 }" :show-word-limit="true" maxlength="150"
							resize="none" type="textarea" placeholder="..." v-model="form.description"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button @click="publish()" type="primary" :disabled="!form.name || !form.description"
							style="width: 100%; margin-top: 12px" :loading="operationInProgress">
							Publish Template
						</el-button>
					</el-form-item>
				</el-form>
			</el-main>
		</el-container>
	</div>
</template>

<script>
import templatePreview from "./templatePreview.vue";
export default {
	components: {
		templatePreview,
	},
	props: {
		workflowToPublish: Object,
		versionId: String,
	},
	data() {
		return {
			operationInProgress: false,
			formRules: {
				name: [{ required: true, message: "A name for the template is required", trigger: "change" }],
				description: [
					{ required: true, message: "A description for the template is required", trigger: "change" },
				],
			},
			form: {
				name: "",
				description: "",
				searchTags: [],
				department: "",
				industry: "",
				public: false,
			},
			tags: [

			],
		};
	},
	methods: {
		publish() {
			let formIsValid;
			this.$refs.form.validate(async (valid) => {
				if (valid) {
					formIsValid = valid;
				}
			});
			if (!formIsValid) {
				return;
			}
			const prevImgcallback = (prevImg) => {
				this.operationInProgress = true;
				this.$confirm("Do you wish to publish this workflow. Continue?", "Warning", {
					confirmButtonText: "OK",
					cancelButtonText: "Cancel",
					type: "warning",
				})
					.then(async () => {
						this.form.description.trim();
						this.form.searchTags = this.form.searchTags.map(t =>
							t.toLowerCase().split(" ").map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(" ")
						);

						if (this.form.department)
							this.form.department = this.form.department.toLowerCase().split(" ").map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");

						if (this.form.industry)
							this.form.industry = this.form.industry.toLowerCase().split(" ").map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");
						const result = await this.httpHelper("RUNTIME", "POST", "template/publishOne", {
							workflowId: this.workflowToPublish.id,
							versionId: this.versionId || null,
							prevImg: prevImg,
							...this.form,
						});
						setTimeout(() => {
							this.operationInProgress = false;
							if (!result?.error) {
								this.$emit("operationComplete");
								this.$notify({
									title: "Success",
									message: "Workflow template published",
									type: "success",
									position: "bottom-left",
								});
							} else {
								this.$notifyError(this, result.error);
							}
						}, 500);
					})
					.catch(() => {
						this.operationInProgress = false;
					});
			};
			this.$refs.templatePreview.saveWorkflowAsImg(prevImgcallback);
		},
	},
};
</script>

<style scoped>
.publishWorkflowFormWrapper {
	padding: 0px;
	padding-bottom: 20px;
	margin-right: 40px;
	width: 40%;
	padding-top: 24px;
}

.compressedDivider {
	margin-bottom: 0px;
}
</style>
